<div class="col-sm-12">
  <div [formGroup]="address">
    <div class="form-group m-form__group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Applicant Address
        <span class="error-msg">*</span>:
      </label>
      <div class="col-xl-9 col-lg-9">
        <textarea class="form-control m-input" placeholder="Enter complete Address of the Applicant" formControlName="addressLine1">
                </textarea>
        <app-form-control-messages class="col-12" [control]="address.get('addressLine1')" [name]="'Address'"></app-form-control-messages>
      </div>
    </div>
    <div class="form-group m-form__group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Nearby Landmark:
      </label>
      <div class="col-xl-9 col-lg-9">
        <input type="text" name="name" class="form-control m-input" placeholder="Enter the nearby Landmark to the above mentioned address"
          formControlName="landmark">
      </div>
    </div>
    <div class="form-group m-form__group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Pincode
        <span class="error-msg">*</span>:
      </label>
      <div class="col-xl-9 col-lg-9">
        <input type="text" name="name" class="form-control m-input" placeholder="Enter the pincode" minlength="6" maxlength="6" formControlName="pincode">
        <app-form-control-messages class="col-12" [control]="address.get('pincode')" [name]="'Pincode'"></app-form-control-messages>
      </div>
    </div>
    <div class="form-group m-form__group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        State/ Union Territory
        <span class="error-msg">*</span>:
      </label>
      <div class="col-xl-9 col-lg-9">
        <div class="input-group">
          <select [compareWith]="showSelected" class="form-control" (change)="getDistrictsInTheState()" formControlName="state">
            <option value="" disabled>Select State/Union Territory</option>
            <option *ngFor="let state of states" [ngValue]="state">{{state.name}}</option>
          </select>
          <app-form-control-messages class="col-12" [control]="address.get('state')" [name]="'state'"></app-form-control-messages>
        </div>
      </div>
    </div>
    <div class="form-group m-form__group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        District/ City
        <span class="error-msg">*</span>:
      </label>
      <div class="col-xl-9 col-lg-9">
        <div class="input-group">
          <select [compareWith]="showSelected" class="form-control" formControlName="district" (change)="getMondelInTheDistrricts()">
            <option [ngValue]="" disabled>Select District</option>
            <option *ngFor="let district of districts" [ngValue]="district">{{district.name}}</option>
          </select>
          <app-form-control-messages class="col-12" [control]="address.get('district')" [name]="'district'"></app-form-control-messages>
        </div>
      </div>
    </div>
    <div class="form-group m-form__group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Tehsil/ Mandal
        <span class="error-msg">*</span>:
      </label>
      <div class="col-xl-9 col-lg-9">
        <div class="input-group">
          <select [compareWith]="showSelected" class="form-control" formControlName="mandal">
            <option [ngValue]="" disabled>Select Tehsil/ Mandal</option>
            <option *ngFor="let mandal of mandals" [ngValue]="mandal">{{mandal.name}}</option>
          </select>
          <app-form-control-messages class="col-12" [control]="address.get('mandal')" [name]="'mandal'"></app-form-control-messages>
        </div>
      </div>
    </div>
    <div class="form-group m-form__group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Parliamentary Constituency
        <span class="error-msg">*</span>:
      </label>
      <div class="col-xl-9 col-lg-9">
        <div class="input-group">
          <select [compareWith]="showSelected" class="form-control" formControlName="parliamentConstituency" (change)="emitValue()">
            <option value="" disabled>Select Parliamentary Constituency</option>
            <option *ngFor="let parliament of parliaments" [ngValue]="parliament">{{parliament.name}}</option>
          </select>
          <app-form-control-messages class="col-12" [control]="address.get('parliamentConstituency')" [name]="'parliamentConstituency'"></app-form-control-messages>
        </div>
      </div>
    </div>
  </div>
</div>
